import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('marketingShortLinkStore')
@observer
class marketingShortLink extends Component {
  render() {
    const { marketingShortLinkStore, location } = this.props
    const { isFetching } = marketingShortLinkStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default marketingShortLink;
